import {LinkScheduleAction} from "@/pages/checks/update/sections/maintenance/actions/LinkScheduleAction.tsx";
import {CheckLinkedSchedulesList} from "@/pages/checks/update/sections/maintenance/CheckLinkedSchedulesList.tsx";

export const CheckLinkedSchedules = () => {
  return (
    <>
      <div className="d-flex align-items-center justify-content-between">
        <div className="pulseTextBodyBold">Linked Schedules</div>
        <LinkScheduleAction />
      </div>
      <CheckLinkedSchedulesList />
    </>
  );
};
